// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'bootstrap';

function noop() {}

if (location.hostname.indexOf("localhost") < 0 && location.hostname.indexOf(".loc") < 0) {
    console.log = noop;
    console.warn = noop;
    console.error = noop;
}



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js